// @flow
import * as React from 'react';
import { Field } from 'formik';

type Props = {
  name: string,
  renderedComponent: React.ComponentType<any>
};

export default function FormikField({
  name,
  // the props should be the union of the props of Component
  renderedComponent: C,
  ...rest
}: Props) {
  return (
    <Field
      name={name}
      render={({ field, form }) => {
        const error = form.errors[name] && form.touched[name];
        return (
          <C type="text" name={name} isInvalid={error} {...rest} {...field} />
        );
      }}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/api/components/FormikField/FormikField.js